module.exports = [{
      plugin: require('../../../.yarn/__virtual__/gatsby-plugin-styled-components-virtual-09b7e201f6/0/cache/gatsby-plugin-styled-components-npm-5.9.0-9a4296dfcf-d0c11d465c.zip/node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../../../.yarn/__virtual__/gatsby-plugin-image-virtual-f149a31c9c/0/cache/gatsby-plugin-image-npm-2.9.0-6349100261-5a5f4c69ee.zip/node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
